import { Price } from 'interfaces/price'

/**
 * Service for product bundle operations
 * Handles product lookup, price extraction, and product information
 */
export class ProductHelper {
  static findProduct(productBundle: any, productId: string): any {
    if (!productBundle) return null

    if (productBundle.base_product?.id === productId) {
      return productBundle.base_product
    }

    const addonProduct = productBundle.addon_products?.find(
      (p: any) => p.id === productId
    )
    if (addonProduct) return addonProduct

    const additionalProduct = productBundle.additional_products?.find(
      (p: any) => p.id === productId
    )
    if (additionalProduct) return additionalProduct

    return null
  }

  static findPrice(
    productBundle: any,
    productId: string,
    priceId: string
  ): Price | undefined {
    if (!productBundle?.prices) return undefined

    const productPrices = productBundle.prices[productId]
    if (!Array.isArray(productPrices)) return undefined

    return productPrices.find((p: any) => p.id === priceId)
  }

  static isAddonProduct(productBundle: any, productId: string): boolean {
    if (!productBundle?.addon_products) return false
    return productBundle.addon_products.some((p: any) => p.id === productId)
  }

  static extractDisplayPrice(price: Price): number {
    const priceAmount = price.unit_amount ? price.unit_amount / 100 : 0

    if (price.unit_amount === null && price.metadata?.internal_description) {
      const priceMatch =
        price.metadata.internal_description.match(/\$[\d,]+\.?\d*/)
      if (priceMatch) {
        return parseFloat(priceMatch[0].replace(/[$,]/g, ''))
      }
    }

    return priceAmount
  }

  static getProductPrices(productBundle: any, productId: string): Price[] {
    if (!productBundle?.prices) return []
    const prices = productBundle.prices[productId]
    return Array.isArray(prices) ? prices : []
  }

  static findOriginalPrice(
    productPrices: Price[],
    periodInMonths: number,
    itemPeriod: string
  ): Price | undefined {
    return productPrices.find((p: any) => {
      const isDiscount =
        p.metadata?.is_discount === true || p.metadata?.is_discount === 'true'
      if (isDiscount) return false

      // Check if billing_period_months matches
      const billingPeriodMonths = p.metadata?.billing_period_months
      if (billingPeriodMonths) {
        return parseInt(billingPeriodMonths, 10) === periodInMonths
      }

      // Fallback: check interval
      if (p.recurring) {
        const priceIntervalCount = p.recurring.interval_count || 1
        const priceIntervalKey =
          priceIntervalCount === 1
            ? p.recurring.interval
            : `${priceIntervalCount}${p.recurring.interval}s`
        const normalizedPriceKey = priceIntervalKey
          .toLowerCase()
          .replace(/\s+/g, '')
        const normalizedPeriod = itemPeriod.toLowerCase().replace(/\s+/g, '')
        return normalizedPriceKey === normalizedPeriod
      }

      return false
    })
  }
}
